import React from "react";
import LoginImage from "assets/images/Login_page.png";
import Logo from "assets/images/Logo.png";
import { Link } from "react-router-dom";

export default function AuthLayout({ children }) {
  return (
    <div className="login-section h-screen overflow-hidden">
      <div className="flex align-items-center justify-content-center h-full flex-wrap">
        <div className="login-img w-12 md:w-6 relative syne h-full">
          <img
            src={LoginImage}
            alt=""
            className="img-cover w-full h-full"
          ></img>
          <h1 className="color-white absolute bottom-0 right-0 text-center md:text-right text-2xl md:text-4xl lg:text-7xl line-height-2">
            Simplify your paperwork and
            <span className="color-egg">set your creativity free</span>
          </h1>
        </div>
        <div className="login-form flex align-items-center w-12 md:w-6 karla px-4 py-6 img-cover md:p-4 h-full overflow-auto">
          <div className="form-wrapper mx-auto max-w-23rem h-full pb-5">
            <Link to="https://athena.appdeft.in/">
              <img src={Logo} alt="" className="mb-5"></img>
            </Link>
            {/* <h2 className={`text-2xl md:text-4xl text-left py-1 mb-2 ${successIcon ? ('flex align-items-center gap-2') : null}`}>{successIcon ? (<img src={successIcon} alt="Success"></img>) : null}
              {title}
              {comapanyName ? (
                <span className="color-sycamore"> {comapanyName}</span>
              ) : null}
            </h2>
            <p className="text-lg text-left">{description}</p> */}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
